import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

// bypass lazy loading for this component only, for Netlify form purposes
import EmbeddedForm from './modules/embeddedForm';

const ImageText = loadable(() => import('./modules/imageText'));
const ConcertBanner = loadable(() => import('./modules/concertBanner'));
const ExploreSlider = loadable(() => import('./modules/exploreSlider'));
const FeaturedLinks = loadable(() => import('./modules/featuredLinks'));
const LatestNews = loadable(() => import('./modules/latestNews'));
const FeaturedImages = loadable(() => import('./modules/featuredImages'));
const FeaturedImageText = loadable(() => import('./modules/featuredImageText'));
const PageBanner = loadable(() => import('./modules/pageBanner'));
const Video = loadable(() => import('./modules/video'));
const SingleColText = loadable(() => import('./modules/singleColText'));
const Resources = loadable(() => import('./modules/resources'));
const InfoTabs = loadable(() => import('./modules/infoTabs'));
const Form = loadable(() => import('./modules/form'));
const ImageSlider = loadable(() => import('./modules/imageSlider'));
const AccordionSet = loadable(() => import('./modules/accordionSet'));
const Timeline = loadable(() => import('./modules/timeline'));
const TeamGrid = loadable(() => import('./modules/teamGrid'));
const TwoColText = loadable(() => import('./modules/twoColText'));
const SupporterGrid = loadable(() => import('./modules/supporterGrid'));
const UpcomingConcerts = loadable(() =>
  import('../portals/venues/upcomingConcerts'),
);
const SeasonImageText = loadable(() => import('./modules/seasonImageText'));
const Quote = loadable(() => import('./modules/quote'));
const DateSlider = loadable(() => import('./modules/dateSlider'));
const ItemGrid = loadable(() => import('./modules/itemGrid'));
const MultiImageText = loadable(() => import('./modules/multiImageText'));
const PdfDownload = loadable(() => import('./modules/pdfDownload'));
const VideoPageBanner = loadable(() => import('./modules/videoPageBanner'));
const IFrame = loadable(() => import('./modules/iFrame'));

const ModuleZone = ({ modules, title, evenCols, isTicketingPage }) => {
  const component = modules.map((item, i) => {
    //get the index of the first supporterGrid module
    const supporterGridIndex = modules?.findIndex(
      (module) => module?._type === 'supporterGrid',
    );
    switch (item._type) {
      case 'imageText':
        return <ImageText {...item} />;
      case 'concertBanner':
        return <ConcertBanner {...item} />;
      case 'exploreSlider':
        return <ExploreSlider {...item} />;
      case 'featuredLinks':
        return <FeaturedLinks {...item} />;
      case 'latestNews':
        return <LatestNews {...item} />;
      case 'featuredImages':
        return <FeaturedImages {...item} />;
      case 'featuredImageText':
        return <FeaturedImageText {...item} />;
      case 'pageBanner':
        return <PageBanner {...item} />;
      case 'video':
        return <Video {...item} />;
      case 'singleColText':
        return <SingleColText {...item} />;
      case 'resources':
        return <Resources {...item} />;
      case 'infotabs':
        return <InfoTabs {...item} evenCols={evenCols} />;
      case 'form':
        return <Form {...item} isTicketingPage={isTicketingPage} />;
      case 'imageSlider':
        return <ImageSlider {...item} />;
      case 'upcoming':
        return <UpcomingConcerts {...item} title={title} />;
      case 'accordionSet':
        return <AccordionSet {...item} />;
      case 'timeline':
        return <Timeline {...item} />;
      case 'teamGrid':
        return <TeamGrid {...item} />;
      case 'twoColumnText':
        return <TwoColText {...item} />;
      case 'supporterGrid':
        return <SupporterGrid {...item} hideLine={i === supporterGridIndex} />;
      case 'quote':
        return <Quote {...item} />;
      case 'dateSlider':
        return <DateSlider {...item} />;
      case 'itemGrid':
        return <ItemGrid {...item} />;
      case 'multiImageText':
        return <MultiImageText {...item} />;
      case 'pdfDownload':
        return <PdfDownload {...item} />;
      case 'videoPageBanner':
        return <VideoPageBanner {...item} />;
      case 'seasonImageText':
        return <SeasonImageText {...item} />;
      case 'embeddedForm':
        return <EmbeddedForm {...item} />;
      case 'iFrame':
        return <IFrame {...item} />;
      default:
        return null;
    }
  });
  return <>{component}</>;
};

ModuleZone.propTypes = {
  modules: PropTypes.array.isRequired,
};

export default ModuleZone;
